import React, { FunctionComponent } from "react"
import FormInput from "../../../components/Form/Inputs/FormInput"
import Upload from "../../../components/Upload/Upload"
import { iSpace } from "../../../definitions/Space"

interface iProps {
  item?: iSpace
}

const SpaceUploads: FunctionComponent<iProps> = ({ item }) => {
  return (
    <div className="scrollable">
      <Upload
        fileCollection="Files_SpacePosters"
        name="previewImageId"
        maxFiles={1}
        initialFiles={[item?.previewImageId || ""]}
        fileType={["image/png", "image/jpeg"]}
        label="Upload poster"
      />
      <Upload
        fileCollection="Files_SpaceScreenshots"
        name="screenshotIds"
        maxFiles={0}
        initialFiles={item?.screenshotIds}
        fileType={["image/png", "image/jpeg"]}
        label="Upload sceenshots"
      />
      <Upload
        name={"floorPlans"}
        fileCollection={"Files_SpaceFloorPlans"}
        maxFiles={0}
        initialFiles={item?.floorPlans}
        label="Upload floor plans"
      />
      <Upload
        name={"mesh"}
        fileCollection={"Files_Meshes"}
        maxFiles={1}
        initialFiles={[item?.mesh || ""]}
        label="Upload mesh"
      />
      <FormInput name="meshguid" label="Mesh GUID" />
    </div>
  )
}

export default SpaceUploads
